export class BackupZeroEtlLakeStorageLocation {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "bucketRegion",
            "baseName": "bucketRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3Uri",
            "baseName": "s3Uri",
            "type": "string",
            "format": ""
        },
        {
            "name": "kmsKeyArn",
            "baseName": "kmsKeyArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableFormat",
            "baseName": "tableFormat",
            "type": "ZeroEtlTableFormat",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlLakeStorageLocation.attributeTypeMap;
    }
    constructor() {
    }
}
